import axios from 'axios';
import { authService } from './authService';

const API_URL = process.env.VUE_APP_API_URL;

//axios.defaults.baseURL = API_URL;
//--------------------------------------------
// const eventSource = new EventSource(API_URL + "sse/notifications");

// eventSource.onmessage = (event) => {
//     console.log("SSE Powiadomienie:", event.data);
//     const data = JSON.parse(event.data);
//     alert(data.message);
// };

// eventSource.onopen = () => {
//     console.log('Połączono z SSE');
//     //reconnectDelay = 1000;  // Resetuj opóźnienie po udanym połączeniu
// };

// eventSource.onerror = (error) => {
//     console.error("Błąd SSE:", error);
// };
//--------------------------------------------

// Ustawienie tokena w nagłówkach
function authHeader() {
    const token = authService.getAuthToken();
    if (token) {
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

export const productOfferService = {
    getProtectedData() {
        return axios.get(API_URL + 'protected/data', { headers: authHeader() });
    },
    //--------------------------------------------------------------------------------
    getProducts(id) {
        return axios.get(API_URL + "productoffer/GetProductsByCategoryId/" + id);
    },
    getProductsBySearchRequest(searchRequest) {
        return axios.post(API_URL + "productoffer/GetProductsBySearchRequest", searchRequest);
    },
    getProductOffersBySearchRequest(searchRequest) {
        return axios.post(API_URL + "productoffer/GetProductOffersBySearchRequest", searchRequest);
    },
    getProductOffersByProductId(productId) {
        return axios.get(API_URL + "productoffer/GetProductOffersByProductId/" + productId);
    },
    GetProductsByProductId(productId) {
        return axios.get(API_URL + "productoffer/GetProductsByProductId/" + productId);
    },
    // GetProductWithAgregateVariantsByProductId(productId) {
    //     return axios.get(API_URL + "productoffer/GetProductWithAgregateVariantsByProductId/" + productId);
    // },
    getCategories(hasBuilder) {
        return axios.get(API_URL + "productoffer/getcategories", {
            params: {
                hasBuilder
            }
        });
    },
    addUpdateProductOffers(data) {
        return axios.post(API_URL + "productoffer/AddUpdateProductOffers", { productId: data.productId, updateWithAi: data.updateWithAi, publishToAllegro: data.publishToAllegro });
    },
    UpdateProductOffersDescriptionJson(data) {
        return axios.post(API_URL + "productoffer/UpdateProductOffersDescriptionJson", { productId: data.productId, offerJson: data.offerJson });
    }

};
